// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {

    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* background-color:  #F3F4F6; */
}
body * {
    font-family: "Spoqa Han Sans Neo";
}

body strong, span, input[type=text] {
    line-height: normal;
    color: #333333;
}

a:link,
a:visited,
a:hover,
a:active {
    text-decoration: none;
}

input:focus-visible {
    outline: none;
}

@-moz-document domain("see.sbi.com.mx") {
    input[type='radio'] {
        height: 16px !important;
        -moz-appearance: radio !important;
    }

    * {
        box-sizing: border-box;
    }
}

#root {
    display: flex;
    min-height: 100%;
}
#commonModalPortal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

button {
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    background-color: transparent;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;IAEI,SAAS;IACT,mCAAmC;IACnC,kCAAkC;IAClC,gCAAgC;AACpC;AACA;IACI,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;;;IAII,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,uBAAuB;QACvB,iCAAiC;IACrC;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,SAAS;IACT,UAAU;IACV,SAAS;IACT,UAAU;IACV,6BAA6B;IAC7B,eAAe;AACnB","sourcesContent":["body {\n\n    margin: 0;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    /* background-color:  #F3F4F6; */\n}\nbody * {\n    font-family: \"Spoqa Han Sans Neo\";\n}\n\nbody strong, span, input[type=text] {\n    line-height: normal;\n    color: #333333;\n}\n\na:link,\na:visited,\na:hover,\na:active {\n    text-decoration: none;\n}\n\ninput:focus-visible {\n    outline: none;\n}\n\n@-moz-document domain(\"see.sbi.com.mx\") {\n    input[type='radio'] {\n        height: 16px !important;\n        -moz-appearance: radio !important;\n    }\n\n    * {\n        box-sizing: border-box;\n    }\n}\n\n#root {\n    display: flex;\n    min-height: 100%;\n}\n#commonModalPortal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n\nbutton {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    outline: 0;\n    background-color: transparent;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
